"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Utilities for development mode
 *
 * Copyright (C) 2018D Noom, Inc.
 * @author hubert
*/
var DevTools = {
  isInDevMode: function isInDevMode() {
    if (typeof ENV !== "undefined") {
      return ENV.NOOM_ENVIRONMENT === "development";
    }

    if (typeof process !== "undefined" && process.env) {
      return process.env.NOOM_ENVIRONMENT === "development";
    }

    return false;
  },
  runInDevMode: function runInDevMode(cb) {
    if (DevTools.isInDevMode()) {
      cb();
    }
  },
  expose: function expose(vars) {
    if (typeof window === "undefined") {
      return;
    }

    if (DevTools.isInDevMode()) {
      _lodash["default"].assign(window, vars);
    }
  },
  exposeOne: function exposeOne(value) {
    if (typeof window === "undefined") {
      return;
    }

    if (DevTools.isInDevMode()) {
      window[value.constructor.name] = value;
    }

    return value;
  }
};
var _default = DevTools;
exports["default"] = _default;